import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
export var AddVoucherErrorCodeV1;
(function(AddVoucherErrorCodeV1) {
    AddVoucherErrorCodeV1[AddVoucherErrorCodeV1[/**
     * Invalid barcode and/or PIN.
     */ "VoucherCredentialsInvalid"] = 12000] = "VoucherCredentialsInvalid";
    AddVoucherErrorCodeV1[AddVoucherErrorCodeV1[/**
     * Voucher already added to the order.
     */ "VoucherAlreadyAdded"] = 12001] = "VoucherAlreadyAdded";
    AddVoucherErrorCodeV1[AddVoucherErrorCodeV1[/**
     * Voucher exists but is no longer able to be used due to it being invalidated in VGC.
     */ "VoucherInvalidated"] = 12002] = "VoucherInvalidated";
    AddVoucherErrorCodeV1[AddVoucherErrorCodeV1[/**
     * No redemptions left.
     */ "NoRedemptionsLeft"] = 12003] = "NoRedemptionsLeft";
    AddVoucherErrorCodeV1[AddVoucherErrorCodeV1[/**
     * Voucher has expired and cannot be used.
     */ "VoucherExpired"] = 12004] = "VoucherExpired";
    AddVoucherErrorCodeV1[AddVoucherErrorCodeV1[/**
     * Voucher type is invalid for requested order (e.g. invalid order type or invalid order selections).
     */ "VoucherInvalidForOrder"] = 12006] = "VoucherInvalidForOrder";
})(AddVoucherErrorCodeV1 || (AddVoucherErrorCodeV1 = {}));
export class AddVoucherErrorV1 extends Error {
    constructor(errorCode){
        const error = `Failed to add voucher. API error code ${errorCode}: ${AddVoucherErrorCodeV1[errorCode]}`;
        super(error);
        this.errorCode = errorCode;
    }
}
export async function getAddVoucherErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(AddVoucherErrorCodeV1).includes(errorCode) ? new AddVoucherErrorV1(errorCode) : error;
}

//# sourceMappingURL=add-voucher-error.js.map